(ns frontend.view.data-import.events
  (:require
   [frontend.conn :as conn]
   [frontend.view.data-import.db :as db]
   [promesa.core :as p]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [cljs.tools.reader.edn :as edn]))

(defn download-template
  [state on-success!]
  (let [options (db/get-template-options state)]
    (-> (conn/sendp! :data-import/get-template (or options {}) 60000)
        (p/then (fn [{:keys [body]}]
                  (when on-success! (on-success!))
                  (if-let [url (:download-url body)]
                    (do
                      (swap! state assoc :download-url url)
                      (aset js/window "location" url))
                    (logging/error "Failed to load import template : " body))))
        (p/catch (fn [e]
                   (logging/error "open-attachment! failed" e))))))

(defn set-step!
  [step]
  (swap! db/import-state assoc :import-step step))

(defn end-processing!
  [job-id result]
  (let [job (get @session/entities job-id)]
    (when (= (:job/status job) :job.status/finished)
      (swap! db/import-state assoc :import-step :import-step-success))
    (when (= (:job/status job) :job.status/error)
      (let [res (->> (edn/read-string (:job/result job))
                     (into {}))]
        (swap! db/import-state assoc
          :import-error-response res
          :import-step :import-step-errors)))))

(defn import-callback!
  [response]
  (let [job-id (:body response)]
    (swap! db/import-state assoc :job-id job-id)
    (session/wait-for-entity-attribute-value! job-id
                                              :job/status
                                              [:job.status/finished :job.status/error]
                                              (partial end-processing! job-id))))


(defn import-file-chosen
  [e state]
  (let [file (aget (-> e
                       .-target
                       .-files)
                   0)]
    (when file
      (swap! db/import-state assoc :import-step :import-step-uploading)
      (conn/upload-import-file! {:file        file
                                 :import-type (:import-type @state)
                                 :filename    (.-name file)}
                                :import-file
                                import-callback!))))

(defn review-import
  [file]
  (swap! db/import-state assoc :uploading-import? true))

(defn end-export!-
  []
  (swap! db/import-state dissoc :uploading-import? false))
